import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import enUS from 'antd/es/locale/en_US';
import 'antd/dist/antd.less';
import Permissions from 'components/helpers/Permissions';
import ScrollToTop from 'components/helpers/ScrollToTop';
import App from 'components-desktop/App/App';
import theme from '../src-common/themes/default';
import './styles.scss';

const render = (AppComponent) => {
  ReactDOM.render(
    <BrowserRouter>
      <ConfigProvider locale={enUS}>
        <Permissions>
          <ScrollToTop>
            {/* Theme support for styled-components */}
            <ThemeProvider theme={theme}>
              <AppComponent />
            </ThemeProvider>
          </ScrollToTop>
        </Permissions>
      </ConfigProvider>
    </BrowserRouter>,
    document.getElementById('root'),
  );
};

render(App);

if (module.hot) {
  module.hot.accept('./components/App/App.jsx', () => { render(App); });
}
